import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import EditForm from '../../../features/components/Forms/EditForm'
import RepresentativeFormFields from './RepresentativeFormFields'

import { usePurifiedFormik } from '../../../hooks/formHooks/usePurifiedFormik'

import {
  clearUpdateSelfAccountRepresentative,
  updateSelfAccountRepresentative
} from '../../../modules/actions/selfAccounts'
import {
  updateSelfAccountRepresentativeErrorSelector,
  updateSelfAccountRepresentativeIsLoadingSelector,
  updateSelfAccountRepresentativeWasUpdatedSelector
} from '../../../modules/selectors/selfAccounts'

import { getInitialValues, representativeValidationSchema } from '../fields'

const RepresentativeUpdateForm = ({ editItemData: representativesList, ...formProps }) => {
  const dispatch = useDispatch()

  const representativeId = formProps.formName

  const successUpdate = useSelector(updateSelfAccountRepresentativeWasUpdatedSelector)

  const handleSubmit = useCallback(
    values => {
      dispatch(updateSelfAccountRepresentative(representativeId, values))
    },
    [dispatch, representativeId]
  )

  const initialValues = useMemo(() => {
    const selectedRepresentative = representativesList.find(item => item.id === representativeId)

    return getInitialValues(selectedRepresentative)
  }, [representativesList, representativeId])

  const formik = useFormik({
    initialValues,
    validationSchema: representativeValidationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const handleClearUpdate = useCallback(() => {
    dispatch(clearUpdateSelfAccountRepresentative())
  }, [dispatch])

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successUpdate}
      clearEditItem={handleClearUpdate}
      errorSelector={updateSelfAccountRepresentativeErrorSelector}
      isLoadingSelector={updateSelfAccountRepresentativeIsLoadingSelector}
      {...formProps}
    >
      <RepresentativeFormFields formik={formik} />
    </EditForm>
  )
}

RepresentativeUpdateForm.propTypes = {
  editItemData: PropTypes.array.isRequired,
  formName: PropTypes.string.isRequired
}

export default RepresentativeUpdateForm
